import React, {useState} from "react"
import PropTypes from "prop-types"
import {Box, Paper, Typography, IconButton, Tooltip} from "@mui/material"
import theme from "../../../../theme/theme"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"
import ExpandLessIcon from "@mui/icons-material/ExpandLess"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"

const AutofillMenu = ({sections}) => {
    const [open, setOpen] = useState(false)

    if (!sections?.length) return null

    return (
        <Box
            sx={{
                position: "fixed",
                right: {xxxs: 12, md: 24},
                bottom: {xxxs: 12, md: 24},
                zIndex: 1200,
            }}
        >
            <Box sx={{display: "flex", justifyContent: "flex-end", mb: open ? 1 : 0}}>
                <IconButton
                    size="small"
                    onClick={() => setOpen((prev) => !prev)}
                    sx={{
                        background: theme.palette.background.secondary,
                        border: `1px solid ${theme.palette.input.borderColor.primary}`,
                        color: theme.palette.common.white,
                        "&:hover": {background: theme.palette.background.secondary},
                    }}
                >
                    {open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                </IconButton>
            </Box>
            {open && (
                <Paper
                    elevation={4}
                    sx={{
                        background: theme.palette.background.secondary,
                        padding: 2,
                        display: "flex",
                        flexDirection: "column",
                        gap: 1,
                        border: `1px solid ${theme.palette.input.borderColor.primary}`,
                    }}
                >
                    <Typography variant="h4" color="common.white" sx={{mb: 1}}>
                        Autofill
                    </Typography>
                    <Box sx={{display: "flex", flexDirection: "column", gap: 1}}>
                        {sections.map((section) => (
                            <Box
                                key={section.key}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    border: `1px solid ${theme.palette.input.borderColor.primary}`,
                                    borderRadius: 1,
                                    px: 1.5,
                                    py: 0.75,
                                }}
                            >
                                <Typography variant="body2" color="common.white">
                                    {section.label}
                                </Typography>
                                <Box sx={{display: "flex", gap: 0.5}}>
                                    <Tooltip title="Preencher válido">
                                        <IconButton
                                            size="small"
                                            onClick={section.onValid}
                                            sx={{color: theme.palette.success.main}}
                                        >
                                            <CheckCircleOutlineIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Preencher inválido">
                                        <IconButton
                                            size="small"
                                            onClick={section.onInvalid}
                                            sx={{color: theme.palette.error.main}}
                                        >
                                            <ErrorOutlineIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Limpar">
                                        <IconButton
                                            size="small"
                                            onClick={section.onClear}
                                            sx={{color: theme.palette.warning.main}}
                                        >
                                            <DeleteOutlineIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                </Paper>
            )}
        </Box>
    )
}

AutofillMenu.propTypes = {
    sections: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            onValid: PropTypes.func.isRequired,
            onInvalid: PropTypes.func.isRequired,
            onClear: PropTypes.func.isRequired,
        })
    ),
}

export default AutofillMenu
